export default __webpack_public_path__ + "static/media/2-1-4.33272fb8.jpg";